/**
 * @namespace buy-list_items-v1
 * @description Mapping of crc error codes for buy/list_items/v1 using service error codes
 * @memberof ux-tread-crc-code
 *
 * @property {string} ITEM_LIMIT_EXCEEDED - 4C5FB5DF Maximum wishlist items exceeded
 * @property {string} NOT_UNIQUE - 91330387 Name is not unique.
 * @property {string} PRODUCT_ALREADY_ADDED - 9008921A Product already added
 * @property {string} WISHLIST_LIMIT_EXCEEDED - 6BD7E72A Maximum wishlists per user exceeded
 */

module.exports = {
  ITEM_LIMIT_EXCEEDED: '4C5FB5DF',
  NOT_UNIQUE: '91330387',
  PRODUCT_ALREADY_ADDED: '9008921A',
  WISHLIST_LIMIT_EXCEEDED: '6BD7E72A',
};
